import type { FC } from 'react';
import { UnitSkillBadge } from './UnitSkillBadge';

interface Props {
  foundationsAllCompleted: boolean;
  supportCompleted: number;
  targetCompleted: number;
}

// The unit header's three progress badges (Foundations / Support / Target), shared by both header
// layouts — inline on the title's row while the unit is in progress, centered below it once complete.
export const UnitSkillBadgeRow: FC<Props> = ({ foundationsAllCompleted, supportCompleted, targetCompleted }) => (
  <div className="tw-flex tw-items-center tw-gap-5">
    <UnitSkillBadge variant="foundations" isActive={foundationsAllCompleted} />
    <UnitSkillBadge variant="support" count={supportCompleted} />
    <UnitSkillBadge variant="target" count={targetCompleted} />
  </div>
);
